import { atom } from "jotai";

export const usingKeyboardAtom = atom<boolean>(false);
export const threadLastVisitedAtAtom = atom<Map<number, Date | null>>(new Map());
